<template>
    <div>
        <!-- <div class="pop_open" @click="showModal">
            <div class="info_icon">
                <SvgHeaderSvg :type="'ask'" />
            </div>
        </div> -->

        <div >
            <Teleport  to="#teleports">
                <div class="modal fade" data-bs-backdrop="true" :id="`modal-${ringBox}`"  tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-body modal-content">                     
                            <div class="">
                                <div class="title_block">
                                    <h3 class="mb-0 font-active" v-if="settingComponent">Side Stone Quantity & Shape</h3>
                                    <h3 class="mb-0 font-active" v-else>Diamond Quantity & Shape</h3>
                                    <span @click="notOpenModal"><SvgHeaderSvg type="close" class="largesvg"/></span>
                                </div>
                                <div class="mt-3 text-center">
                                    <div class="image_block my-3">
                                        <img v-for="(imageName, index) in imageNames" :key="index" width="115" height="72" :src="`/settingactive/${imageName}.svg`" :alt="imageName" />
                                    </div>
                                    
                                    <p class="mb-0" v-if="addtionalAttirbute">Quantity : <b>{{addtionalAttirbute}}</b></p>
                                    <p class="mb-0" v-else>Quantity : <b>{{settingComponent.side_stone.diamonds}}</b></p>

                                    <div class="text-center shape_block">
                                        <p class="mb-0" v-if="type === 'preset'">Shape : <b>{{ settingComponent.side_stone_shape }}</b>
                                        </p>
                                        <p v-if="currentMetal?.sub_type && ['toi-et-moi-ring', 'full-eternity-ring', 'anniversary-ring', 'couple-bands-ring','fashion-earring', 'tennis-bracelet' ,'fashion-bracelet', 'stud-earring','hoop-earring',
                                        'tennis-necklace','solitaire-necklace','band-ring'].includes(currentMetal.sub_type)" class="mb-0">
                                            Shape :  <b>{{ currentMetal.shape }}<span v-if="currentMetal?.side_stone_shape">, {{ currentMetal.side_stone_shape }}</span></b>
                                        </p>
                                    </div>
                                    <!-- <p class="mt-2 mb-0 text-start">Accent diamonds are smaller diamonds that are placed around or next to the centerstone in a {{moduleSubType}} to enhance its look. The number and shape of these side stones can enhance the look of a design.</p> -->
                                    <p class="mt-2 mb-0 text-start">Diamond quantity refers to the total number of diamonds featured in a {{ $t('jewelry') }} piece, including the smaller accent stones.</p>
                                </div>

                                <p class="mt-1 mb-0 text" v-if="showDefaultText">
                                    *The number of diamonds may vary as per the total carat weight and the {{detailData}} length.
                                </p>
                                
                                <p class="mt-1 mb-0 text" v-if="showSolitaireNecklaceText">
                                    *The number of diamonds may vary as per the total carat weight.
                                </p>
                              
                                <!-- For Preset Only  -->
                                <p class="mt-1 mb-0 text" v-if="isPreset">
                                    *The number of accent diamonds may vary as per the ring size and the carat weight of the centre diamond.
                                </p>

                                <!-- dynamic below for eternity -->
                                <p class="mt-1 mb-0 text" v-if="showIndiaEternityText">
                                    *Shown as per ring size IN 14. The number of diamonds may vary according to the {{detailData}} size and the total carat weight selected.
                                </p>
                                <p class="mt-1 mb-0 text" v-if="showNonIndiaEternityText">
                                    *Shown as per ring size US 7. The number of diamonds may vary according to the {{detailData}} size and the total carat weight selected.
                                </p>

                                <!-- wedding band only -->
                                <p class="mt-1 mb-0 text" v-if="showWeddingBandText">
                                    *The number of accent diamonds may vary according to the {{detailData}} size.
                                </p>

                                <p class="mt-1 mb-0 text" v-if="isHoopEarring">
                                    *The number of accent diamonds may vary as per total carat weight.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Teleport>
        </div>
     
    </div>
   
</template>

<script setup>
    const flagShowModal = ref(false);
    const shape = ref(null);
    const props = defineProps(['currentMetal','settingComponent','addtionalAttirbute', 'type','moduleSubType','detailData','ringBox'])
 

    const { $country } = useNuxtApp()
    const imageNames = ref([]);

    const active = ref(props.ringBox)
    const notOpenModal = () => {
        emit('close');
        active.value = null;
    };
    const emit = defineEmits(['close']);



    const sortImages = () => {
        // Checking for 
        if ([
                'toi-et-moi-ring',
                'tennis-bracelet',
                'couple-bands-ring',
                'hoop-earring',
                'stud-earring',
                'fashion-earring',
                'tennis-necklace',
                'solitaire-necklace',
                'full-eternity-ring',
                'anniversary-ring',
                'band-ring',
                'fashion-bracelet'
            ].includes(props.currentMetal?.sub_type)) {
            //  shape and side_stone_shape exist?? 

            const shape = props.currentMetal?.shape || '';
            const sideStoneShape = props.currentMetal?.side_stone_shape || '';

            if (sideStoneShape) {
                // If side_stone_shape is not empty, use both shape and side_stone_shape
                const metalString = `${shape},${sideStoneShape}`;
                imageNames.value = metalString
                    .toLowerCase()                  // Convert to lowercase
                    .replace(/[\s-]+/g, '')         // Remove spaces and hyphens
                    .split(',')                     // Split by comma
                    .map(name => name.trim());      // Trim each part
            } 
            else {
                // If side_stone_shape is empty, use only shape
                imageNames.value = shape
                    .toLowerCase()                  // Convert to lowercase
                    .replace(/[\s-]+/g, '')         // Remove spaces and hyphens
                    .split(',')                     // Split by comma
                    .map(name => name.trim());      // Trim each part
            }
            } 
            else if (props.settingComponent || props.type === 'preset') {
            const sideStoneShape = props.settingComponent.side_stone_shape || '';
            imageNames.value = sideStoneShape
            .toLowerCase()
            .replace(/[\s-]+/g, '')
            .split(',')
            .map(name => name.trim());
        }
    };

//     const sortImages = () => {
    
//     const metalString = props.currentMetal.shape && props.currentMetal.side_stone_shape || props.settingComponent.side_stone_shape ;

//     console.log(metalString);
//     imageNames.value = metalString
//         .toLowerCase()                  // Convert to lowercase
//         .replace(/[\s-]+/g, '')         // Remove spaces and hyphens
//         .split(',')                     // Split by comma
//         .map(name => name.trim());      // Trim each part
// };
       
// only for necklace and tennis
        const showDefaultText = computed(() => {
            return !(props.currentMetal?.sub_type && [
                'toi-et-moi-ring',
                'solitaire-necklace',
                'full-eternity-ring',
                'couple-bands-ring',
                'band-ring',
                'hoop-earring',
                'anniversary-ring',
                'stud-earring',
                'fashion-earring',
            ].includes(props.currentMetal.sub_type)) && props.type !== 'preset';
        });

        const showSolitaireNecklaceText = computed(() => {
            return props.currentMetal?.sub_type && ['solitaire-necklace'].includes(props.currentMetal.sub_type);
        });
        const isPreset = computed(() => {
            return props.type === 'preset';
        });

        const showIndiaEternityText = computed(() => {
            return $country.is_india && props.currentMetal?.sub_type === 'full-eternity-ring';
        });

        const showNonIndiaEternityText = computed(() => {
            return !$country.is_india && props.currentMetal?.sub_type === 'full-eternity-ring';
        });

        const showWeddingBandText = computed(() => {
            return !(props.currentMetal?.sub_type && ['full-eternity-ring', 'tennis-bracelet','fashion-bracelet', 'stud-earring', 'hoop-earring', 'tennis-necklace', 'solitaire-necklace'].includes(props.currentMetal.sub_type)) && props.type !== 'preset';
        });

        const isHoopEarring = computed(() => {
            return props.currentMetal?.sub_type === 'hoop-earring';
        });

    const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
        const modalElement = shape.value;
        if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
        }
        });
    };

    const hideModal = () => {
        const modalElement = shape.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };

    onMounted(() => {
        sortImages();
    });


</script>



<style scoped>
.text{
    font-size: 14px;
    font-style: italic;
    color: #909090;
}
.largesvg {
    transform: scale(1.3);
    }

.img_box{
    height: 130px;
}

.pop_open{
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

p {
    font-size: 16px;
    color: #606060;
}
.title_block span {
    cursor: pointer;
}
h3{
    font-size: 22px;
}
.m-info {
    margin: 10px 0;
}

.shape_block{
    text-transform: capitalize;
}

@media(max-width: 767px){
    h3 {
        font-size: 20px;
    }
    p {
        font-size: 14px;
    }
    .text{
        font-size: 12px;
    }

}
</style>
